"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Light = void 0;
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Light = exports.Light = /*#__PURE__*/function () {
  function Light(anchor, count, colors, scaleView, rangePos, rangeAngle, offsetA) {
    _classCallCheck(this, Light);
    _defineProperty(this, "count", void 0);
    _defineProperty(this, "view", void 0);
    _defineProperty(this, "colors", void 0);
    _defineProperty(this, "rangePos", void 0);
    _defineProperty(this, "rangeAngle", void 0);
    _defineProperty(this, "scaleView", void 0);
    _defineProperty(this, "offsetA", void 0);
    _defineProperty(this, "w", void 0);
    _defineProperty(this, "h", void 0);
    var sprite = new _pixi.Sprite(_pixi.Texture.from("lightning_01.png"));
    sprite.anchor.set(anchor.x, anchor.y);
    sprite.blendMode = _pixi.BLEND_MODES.ADD;
    this.count = Math.random() * count;
    this.view = sprite;
    this.colors = colors;
    this.rangePos = rangePos;
    this.rangeAngle = rangeAngle;
    this.offsetA = offsetA;
    this.scaleView = scaleView;
  }
  return _createClass(Light, [{
    key: "random",
    value: function random(min, max) {
      return Math.random() * (max - min) + min;
    }
  }, {
    key: "init",
    value: function init() {
      this.view.tint = this.colors[Math.floor(Math.random() * this.colors.length)];
      var angle = Math.random() * Math.PI * 2;
      this.view.position.x = this.w / 2 + Math.cos(angle) * this.random(this.rangePos[0], this.rangePos[1]);
      this.view.position.y = this.h / 2 + Math.sin(angle) * this.random(this.rangePos[0], this.rangePos[1]);
      this.view.scale.set(Math.random() * this.scaleView);
      var dir = {
        x: this.w / 2 - this.view.position.x,
        y: this.view.position.y - this.h / 2
      };
      if (this.offsetA) {
        this.view.rotation = Math.atan2(dir.x, dir.y) + Math.PI / 180 * 90 + Math.PI / 180 * this.random(-this.rangeAngle[0], this.rangeAngle[1]);
      } else {
        this.view.rotation = Math.atan2(dir.x, dir.y);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.count = 0;
      this.view.tint = this.colors[Math.floor(Math.random() * this.colors.length)];
      var angle = Math.random() * Math.PI * 2;
      this.view.position.x = this.w / 2 + Math.cos(angle) * (this.random(this.rangePos[0], this.rangePos[1]) + radius);
      this.view.position.y = this.h / 2 + Math.sin(angle) * (this.random(this.rangePos[0], this.rangePos[1]) + radius);
      this.view.scale.set(Math.random() * this.scaleView);
      var dir = {
        x: this.w / 2 - this.view.position.x,
        y: this.view.position.y - this.h / 2
      };
      if (this.offsetA) {
        this.view.rotation = Math.atan2(dir.x, dir.y) + Math.PI / 180 * 90 + Math.PI / 180 * this.random(-this.rangeAngle[0], this.rangeAngle[1]);
      } else {
        this.view.rotation = Math.atan2(dir.x, dir.y);
      }
    }
  }, {
    key: "resize",
    value: function resize(w, h) {
      this.w = w;
      this.h = h;
    }
  }]);
}();
//# sourceMappingURL=Light.js.map